module.exports = __webpack_public_path__ + "static/media/1992_GDP_totalRate.76769949.png";